import { UseQueryResult } from '@tanstack/react-query';

import { useGraphql } from '@app/hooks/useGraphql';
import { useInsightsContext } from '@insights_module/context/InsightsContext';
import { useShowDetailsContext } from '@insights_module/context/ShowDetailsContext';
import { GraphqlQueryDataResponse } from '@insights_module/types/graphql/ClientTypes';

export const useGraphqlShowDetails = (groupId: string, useGarmScoreDate?: boolean) => {
  const { data, ...rest } = useGraphql({
    queryKey: ['graphql', 'graphql-group', groupId, useGarmScoreDate],
    graphqlQuery: groupDetailsQuery,
    variables: { groupId, useGarmScoreDate },
    enabled: !!groupId,
  }) as { data: GraphqlQueryDataResponse } & UseQueryResult<unknown, unknown>;

  return { data: data?.data?.group, ...rest };
};

export const useSelectedShowDetails = () => {
  const { selectedShow } = useInsightsContext();
  const { showLast90Days } = useShowDetailsContext();

  return useGraphqlShowDetails(selectedShow, showLast90Days);
};

const groupDetailsQuery = `query GroupDetails($groupId: String, $useGarmScoreDate: Boolean) {
  group(id: $groupId, use_garm_score_date: $useGarmScoreDate) {
    id
    name
    type
    thumbnail_url
    tenant_id
    audio_count
    most_recently_published_audio_date
    external_ids {
      name
      value
    }
    extra_fields {
      name
      value
    }
    podcast_metadata {
      apple_categories
      apple_rating_count
      apple_star_rating
      author
      description
      podcast_type
    }
    created_at
    updated_at
    garm {
      adult_explicit_content
      arms_ammunition
      crime_harmful_act
      death_injury_military_conflict
      debated_social
      illegal_drugs
      hate_speech
      obscenity
      online_piracy
      spam_harmful
      terrorism
    }
    contextual {
      name
      id
      display_name
      taxonomy {
        taxonomy
        name
        tier
        id
        parent_id
      }
      audio_count
    }
    linked_named_entities {
      id
      type
      value
      audio_count
    }
    processed_audios_details {
      processed_audio_count
      most_recently_processed_audio_date
    }
    episodes_related_to_garm_score_count
    garm_brand_safety_summery {
      adult_explicit_content {
        unrelated
        low
        medium
        high
        floor
      }
      arms_ammunition {
        unrelated
        low
        medium
        high
        floor
      }
      crime_harmful_act {
        unrelated
        low
        medium
        high
        floor
      }
      death_injury_military_conflict {
        unrelated
        low
        medium
        high
        floor
      }
      debated_social {
        unrelated
        low
        medium
        high
        floor
      }
      illegal_drugs {
        unrelated
        low
        medium
        high
        floor
      }
      hate_speech {
        unrelated
        low
        medium
        high
        floor
      }
      obscenity {
        unrelated
        low
        medium
        high
        floor
      }
      online_piracy {
        unrelated
        low
        medium
        high
        floor
      }
      spam_harmful {
        unrelated
        low
        medium
        high
        floor
      }
      terrorism {
        unrelated
        low
        medium
        high
        floor
      }
    }
  }
}
`;
